<div class="premium-reports">
  <div class="reports-container">
    <div class="header">
      <h1>Reports</h1>
      <span class="header-muted" *ngIf="selectedSection">
        {{ selectedSection.availableReports.length }}
        {{ selectedSection.availableReports.length === 1 ? 'report' : 'reports' }}
      </span>
    </div>

    <div class="section-tabs" role="tablist" aria-label="Report sections" *ngIf="sections.length">
      <button *ngFor="let section of sections; let i = index" type="button" role="tab" class="section-tab"
        [class.active]="i === selectedSectionIndex" [attr.aria-selected]="i === selectedSectionIndex"
        (click)="selectSection(i)">
        {{ section.type }}
      </button>
    </div>

    <div class="bento-grid" *ngIf="selectedSection as section">
      <button *ngFor="let report of section.availableReports; trackBy: trackByName" type="button"
        class="bento-card report-card" (click)="openReport(report)">
        <div class="card-header">
          <!-- Document outline with the backend's downloadFormat as the badge text (Material Icons has no CSV glyph). -->
          <svg class="report-icon format-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M3.5 2.5h11.5l5.5 5.5v13.5h-17z M15 2.5v5.5h5.5" fill="none" stroke="currentColor"
              stroke-width="1.5" stroke-linejoin="round" />
            <text x="12" y="17.3" text-anchor="middle" font-size="6.6" font-weight="500" fill="currentColor"
              font-family="Roboto, Arial, sans-serif">{{ formatOf(report) }}</text>
          </svg>
        </div>
        <div class="report-name">{{ report.name }}</div>
        <div class="report-meta">
          <span>{{ inputsLabel(report) }}</span>
          <mat-icon class="download-icon" aria-hidden="true">file_download</mat-icon>
        </div>
      </button>

      <div class="bento-card span-12 empty-card" *ngIf="!section.availableReports.length">
        No reports available in this section.
      </div>
    </div>

    <div class="bento-card empty-card" *ngIf="!sections.length">No reports available.</div>
  </div>
</div>
